import { atomWithReset } from 'jotai/utils';

type TSimpleToastStatus =
  | false
  | {
      content: string;
    };

export const $SimpleToastStatus = atomWithReset<TSimpleToastStatus>(false);
$SimpleToastStatus.debugLabel = '$SimpleToastStatus';
